export default __webpack_public_path__ + "static/media/5.11ff5458.png";